define('SageDotCom/Components/CareerSearchLanding',["Pagination",
    "knockout",
    "underscore",
    "eventManager",
    "SageDotCom/Utility/sanitizer",
    "jqueryChosen",
    "jqueryQuerystring",
    "knockoutChosen"
],
    function ($, ko, _, eventManager, sanitizer) {

        function CareerSearch(scope, SearchResultPage, FunctionsLabel) {
            Object.defineProperties(this, {
                $scope: { enumerable: true, value: $(scope) }
            });

            function CallController() {
                $.getJSON("/api/sagedotcom/CareerSearch/GetCareerSearchData", null, function (data) {
                    if (typeof (data) !== "undefined" && data !== null) {

                        var view = new CareersViewModel(data.vacancies.Records);

                        ko.applyBindings(view);

                    }
                });
            }
           
            function CareersViewModel(data) {

                var self = this;

                self.selectedCountry = ko.observable();
                self.selectedFunction = ko.observable();
                self.countries = ko.computed(function () {
                    var listOfAllCountries = [];
                    _.each(data, function (country) {
                        if (country.Country !== null) {
                            listOfAllCountries.push(country.Country);
                        }

                    });
                    return ko.utils.arrayGetDistinctValues(listOfAllCountries).sort();
                });
                
                self.selectedCountry.subscribe(function (value) {
                    eventManager.trigger("facet-selected", scope, "Country", value);
                });
                self.selectedFunction.subscribe(function (value) {
                    eventManager.trigger("facet-selected", scope, "Function", value);
                });
                var FunctionsList = function (optionText, optionValue) {
                    this.optionText = optionText;
                    this.optionValue = optionValue;
                };
                self.functions = ko.computed(function () {
                    var country = self.selectedCountry();
                    var functions = ko.utils.arrayMap(data, function (item) { return { function: item.Function, country: item.Country }; });
                    
                    var filteredFromThatCountry = [];
                    var filteredNotConnectedToCountry = [];
                    if (typeof country !== 'undefined' && country.length > 0 && country[0] !== "") {
                        _.each(functions, function (item) {
                            if (item.country === country[0] && item.function !== null) {
                                filteredFromThatCountry.push(item.function);
                            }
                        });
                        _.each(functions, function (item) {
                            if (item.country !== country[0] && item.function !== null) {
                                filteredNotConnectedToCountry.push(item.function);
                            }
                        });
                        
                    }
                    else {
                        _.each(functions, function (item) {
                            if (item.function !== null) {
                                filteredFromThatCountry.push(item.function);
                            }
                        });
                    }
                    var countFunctions = 1;
                    var finalListOfFunctions = [];
                    if (typeof filteredFromThatCountry !== 'undefined') {
                        for (let i = 0; i < filteredFromThatCountry.length; i++) { 
                            var indexOf = filteredFromThatCountry.indexOf(filteredFromThatCountry[i]);
                            //check if elements are not repeated
                            if (indexOf === i) {
                                for (let j = i + 1; j < filteredFromThatCountry.length; j++) {
                                    // check if elements' values are equal
                                    if (filteredFromThatCountry[i] === filteredFromThatCountry[j]) {
                                        // duplicate element present increase count of occurence  
                                        countFunctions++;

                                    }

                                }
                                finalListOfFunctions.push(new FunctionsList(filteredFromThatCountry[i] + " (" + countFunctions + ")", filteredFromThatCountry[i]));
                                countFunctions = 1;
                            }
                        }
                    }   
                    if (typeof filteredNotConnectedToCountry !== 'undefined') {
                        for (let i = 0; i < filteredNotConnectedToCountry.length; i++) { 
                            var indexOf = filteredNotConnectedToCountry.indexOf(filteredNotConnectedToCountry[i]);
                            //check if elements are not repeated
                            if (indexOf === i) {
                                var isInOtherList = filteredFromThatCountry.indexOf(filteredNotConnectedToCountry[i]);
                                if (isInOtherList < 0) {
                                    finalListOfFunctions.push(new FunctionsList(filteredNotConnectedToCountry[i] + " (0)", filteredNotConnectedToCountry[i]));
                                }
                                
                            }

                        }
                    }
                    return ko.utils.arrayGetDistinctValues(finalListOfFunctions).sort(function (left, right) { return left.optionValue == right.optionValue ? 0 : (left.optionValue < right.optionValue ? -1 : 1) })
               
                });

                self.redirect = function () {
                    var func = self.selectedFunction();
                    var country = self.selectedCountry();
                    var queryString = "?";
                    if (!func) {
                    } else {
                        func = func.replace(/[\s+\(\d+\)]*$/g, "");
                        queryString += "function=" + func + "&";
                    }
                    if (!country) {
                    } else {
                        queryString += "country=" + country + "&";
                    }
                    queryString += "page=1";

                    if (!sanitizer.containsHTML(SearchResultPage) && !sanitizer.containsHTML(queryString)) {
                        window.location.href = SearchResultPage + queryString;
                    } else {
                        console.error("Invalid URL: " + SearchResultPage + queryString);
                    }
                };

                self.setAriaLabels = function (option, item) {
                    option.setAttribute("aria-label", option.text);
                }
            }
            CallController();
        }

        return function init(args) {
            return args.IsExperienceEditorEditing ? null : new CareerSearch(args.scope, args.SearchResultPage, args.FunctionsLabel);
        };
    });


